const sortString = (a: string, b: string): number => a.localeCompare(b);
const sortNumber = (a: number, b: number): number => a - b;

export const arraysOfStringsAreDifferent = (a: string[], b: string[]): boolean => {
    return [...a].sort(sortString).join() !== [...b].sort(sortString).join();
};

export const arraysOfNumbersAreDifferent = (a: number[], b: number[]): boolean => {
    return JSON.stringify([...a].sort(sortNumber)) !== JSON.stringify([...b].sort(sortNumber));
};
